<template>
  <div class="">
    <b-row>


      <b-col>
        <b-button
            @click="setDirectoryWrapper()"
            variant="warning"
            size="sm"
            type="button"
            class="mb-2 ml-2">
          <i class="fas fa-folder-open"></i>
          <span class="d-none d-sm-inline">
          بازگشت
          </span>
        </b-button>

        <b-modal id="upload-file" hide-footer>

          <form @submit.prevent="uploadFiles">

            <form-group class="col text-right Font" :validations="$v.uploadSection.uploadDirectory">
              <div slot-scope="{ errors, invalid }">

                <label class="float-right">انتخاب پوشه</label>
                <b-form-select v-model="uploadSection.uploadDirectory" :options="getDirectories"></b-form-select>

                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>


            <form-group class="col text-right Font" :validations="$v.uploadSection.selectedFiles">
              <div slot-scope="{ errors, invalid }">

                <label class="col-lg-12 text-right mt-3">انتخاب فایل ها</label>
                <b-form-group>
                  <b-form-file v-model="uploadSection.selectedFiles" multiple id="file-default"></b-form-file>
                </b-form-group>

                <form-errors-manager :errors="errors"/>
              </div>
            </form-group>

            <!--
            v-if="uploadPercent > 0"
            -->


            <div class="" v-if="uploadPercent > 0">
              <span class="text-center">درصد آپلود شده: %{{ uploadPercent }}</span>
              <div class="progress m-2 ">
                <div class="progress-bar" role="progressbar" :style="{width:`${uploadPercent}%`} " aria-valuenow="25"
                     aria-valuemin="0" aria-valuemax="100"></div>
              </div>


              <span class="btn col-lg-12 mb-2 btn-sm ml-auto mr-auto btn-danger" @click="cancelUpload()">
                <b-icon icon="x"></b-icon>
              </span>
            </div>


            <b-button type="submit" variant="primary" class="float-right col-lg-12">
              <i class="fas fa-upload"></i>
              <span class="d-none d-sm-inline">
              آپلود
              </span>
            </b-button>

          </form>

        </b-modal>

        <b-button
            v-b-modal.upload-file
            variant="primary"
            size="sm"
            type="button"
            class="mb-2 ml-2">
          <i class="fas fa-folder-open"></i>
          <span class="d-none d-sm-inline">
          اپلود فایل
          </span>
        </b-button>

        <b-button
            v-b-toggle.create-folder
            variant="primary"
            size="sm"
            type="button"
            class="mb-2 ml-2">
          <i class="fas fa-folder-open"></i>
          <span class="d-none d-sm-inline">
          ساخت پوشه
          </span>
        </b-button>
        <b-collapse id="create-folder" class="mt-2 mb-4">

          <form-group class="col text-right Font" :validations="$v.form.name">
            <div slot-scope="{ errors, invalid }">


              <b-input-group class="mb-3">

                <b-input-group-append>
                  <b-button size="sm" text="ثبت" @click="createDirectory()" variant="success">ثبت</b-button>
                </b-input-group-append>

                <b-form-input v-model="form.name" placeholder="نام پوشه را وارد کنید"></b-form-input>

              </b-input-group>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>


        </b-collapse>
      </b-col>

    </b-row>
    <b-row>
      <b-col v-if="directoryMode === 'directory'" v-for="(directory,index) in getDirectories" :key="index"
             @dblclick="directoryFiles(directory)"
             class="text-center cursor_pointer" lg="4">
        <b-icon class="h1" icon="folder"></b-icon>
        <p class="bg text-white bg-info rounded">{{ directory }}</p>
      </b-col>

      <b-col v-if="directoryMode === 'file'" v-for="(file,index) in files" :key="index"
             class="text-center cursor_pointer" lg="2">

        <img class="col-lg-12 mt-3" :src="file.file" v-if="imageTypes.indexOf(file.file.split('.').slice(-1)[0])!==-1"
             alt="">

        <div v-else>
          <b-icon class="h1" icon="file-earmark"/>
          <span class="badge text-wrap d-block mt-2 badge-primary">{{
              file.file.split('/').slice(-1)[0].match(/.{1,4}/g).join(' ')
            }}</span>
        </div>

        <div class="bg bg-info rounded mt-2 p-1 text-white">
          <b-icon class="h3 col-6" @click="destroyFile(file.id)" icon="trash"/>
          <b-icon class="h3 col-6" @click=" copyToClipBoard(file.file)" icon="link45deg"/>
        </div>

      </b-col>

    </b-row>

    <b-row v-if="directoryMode === 'file'" class="mt-5">
      <Pagination :meta="meta" :onChangePage="changePage"/>
    </b-row>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Pagination from "../../components/dashboard/Pagination.vue";
import FormGroup from "../../components/validator/FormGroup";
import FormErrorsManager from "../../components/validator/FormErrorsManager";
import {required} from "vuelidate/lib/validators";
import {slug} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "FileManager",
  data() {
    return {
      directoryMode: 'directory',
      imageTypes: ['jpg', 'jpeg', 'png'],
      directory: '',
      form: {
        name: "", // directory name
      },
      uploadSection: {
        uploadDirectory: '',
        selectedFiles: [],
      }
    }
  },
  validations: {
    form: {
      name: {required, slug}, // directory name
    },
    uploadSection: {
      uploadDirectory: {required},
      selectedFiles: {required},
    }
  },
  components: {Pagination, FormGroup, FormErrorsManager},
  computed: {
    ...mapGetters({
      files: 'FileManager/getFiles',
      meta: 'FileManager/getPagination',
      getDirectories: "FileManager/getDirectories",
      uploadPercent: "FileManager/getUploadPercent",
    })
  },
  mounted() {
    this.setDirectoryWrapper();
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    createDirectory() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        this.$store.dispatch('FileManager/createDirectory', this.form)
      }
    },
    directoryFiles(directory) {
      this.directoryMode = 'file';
      this.directory = directory;
      this.$store.dispatch('FileManager/directoryFiles', {directory: directory, page: 1})
    },
    async setDirectoryWrapper() {
      await this.$store.dispatch('FileManager/setDirectories').then(async (res) => {
        this.directoryMode = 'directory';
      })
    },
    changePage(page) {
      const directory = this.directory
      this.$store.dispatch("FileManager/directoryFiles", {directory: directory, page: page});

    },
    destroyFile(fileId) {
      const form = {id: fileId}
      if (confirm('آیا مطمئن هستید؟')) {
        this.$store.dispatch('FileManager/deleteFile', form)
      }
    },
    copyToClipBoard(value) {
      navigator.clipboard.writeText(value);
      toast('عملیات با موفقیت انجام شد', 'کپی شد.', 'success')
    },
    uploadFiles() {
      this.$v.uploadSection.$touch();
      if (!this.$v.uploadSection.$invalid) {
        this.$store.dispatch('FileManager/uploadFiles', this.uploadSection)
      }
    },
    cancelUpload() {
      if (confirm('مطمئن هستید؟')) {
        this.$store.dispatch('FileManager/cancelUpload')
      }
    }
  }
};
</script>
<style>
.cursor_pointer {
  cursor: pointer;
}
</style>
